import React from 'react';

// variant maps to the bs/bw/bd/bg/bp color classes from our mockups
const VARIANT_STYLES = {
  success: { background: '#E1F5EE', color: '#0F6E56' },
  warning: { background: '#FAEEDA', color: '#854F0B' },
  danger: { background: '#FCEBEB', color: '#A32D2D' },
  neutral: { background: '#F0F0F0', color: '#666666' },
  purple: { background: '#EEEDFE', color: '#3C3489' },
};

export default function Badge({ children, variant = 'neutral', icon = null }) {
  const style = VARIANT_STYLES[variant] || VARIANT_STYLES.neutral;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '3px 9px',
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {icon}
      {children}
    </span>
  );
}

// Why new dancers/entries/staff are closed, from /api/teacher/school-locks:
// not registered for the event (red), waitlisted, withdrawn, or locked.
export function LockBadge({ locks }) {
  const label = locks?.notRegistered ? 'Not registered'
    : locks?.waitlisted ? 'Waitlisted'
      : locks?.withdrawn ? 'Withdrawn'
        : 'Locked';
  return <Badge variant={locks?.notRegistered ? 'danger' : 'neutral'}>{label}</Badge>;
}
